import React from "react";
import { useLang } from "../LangContext";
import { useReveal } from "../hooks/useReveal";
import { Kicker } from "./Mission";
import { Quote } from "lucide-react";

export const Manifesto = () => {
  const { t } = useLang();
  const ref = useReveal();

  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative py-28 lg:py-40 overflow-hidden reveal"
      ref={ref}
    >
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-[#070a14]" />
        <div className="absolute inset-0 bg-[radial-gradient(900px_500px_at_50%_30%,rgba(139,92,246,0.22),transparent_60%)]" />
      </div>

      <div className="max-w-5xl mx-auto px-6 lg:px-8 text-center">
        <div className="flex justify-center">
          <Kicker label={t.manifesto.kicker} />
        </div>
        <h2
          className="font-display mt-6 text-5xl sm:text-6xl lg:text-7xl xl:text-8xl font-extrabold tracking-tight leading-[0.95]"
          data-testid="manifesto-title"
        >
          <span className="block text-white">{t.manifesto.title1}</span>
          <span className="block text-baj-grad italic">
            {t.manifesto.title2}
          </span>
          <span className="block text-white">{t.manifesto.title3}</span>
        </h2>

        <div className="mt-12 relative max-w-3xl mx-auto">
          <Quote className="w-10 h-10 text-fuchsia-400/60 mx-auto" />
          <p className="mt-4 text-xl sm:text-2xl text-slate-200 leading-[1.55] font-medium">
            {t.manifesto.text}
          </p>
        </div>

        <div className="mt-14 inline-flex items-center gap-3 glass rounded-full pl-2 pr-5 py-1.5">
          <span className="w-7 h-7 rounded-full bg-baj-grad flex items-center justify-center text-[10px] font-black">
            BàJ
          </span>
          <span className="text-sm font-semibold text-slate-200">
            Bac à jeux — Poissy, France
          </span>
        </div>
      </div>
    </section>
  );
};
